import http from './http'

class Assignor {
  get (id) {
    return http.get(`/assignors/${id}`)
  }

  all () {
    return http.get('/assignors?per_page=all')
  }

  save (payload) {
    return http.post('/assignors', { assignor: payload })
  }

  update (payload) {
    return http.put(`/assignors/${payload.id}`, { assignor: payload })
  }

  allElegible () {
    return http.get('/assignors_eligible?per_page=100')
  }

  current () {
    return http.get('/current_assignor')
  }

  withInvoices () {
    return http.get('/assignors_with_invoices')
  }

  documents (id) {
    return http.get(`/assignors/${id}/get_assignor_documentation`)
  }

  users (id) {
    return http.get(`/api/assignors/${id}/users`)
  }

  byPayers () {
    return http.get('/assignors_by_payer')
  }

  getClassifiedAssignorByPayer (payerId, queryParams) {
    return http.get(
      `/abc/class_assignors/assignors_with_classification/by_payer/${payerId}`,
      { params: queryParams }
    )
  }

  classification (groupTaxId, assignorId) {
    return http.post(`/abc/class_assignors/classify/${groupTaxId}`, {
      assignor_id: assignorId
    })
  }

  checkSerasa (assignorId) {
    return http.get(`/assignors_serasa/${assignorId}`)
  }

  sendDocumentations (id, payload) {
    return http.put(`/assignors/${id}/send_documentations`, payload)
  }

  templateContractOptions () {
    return http.get('/assignors/template_contract_options')
  }

  byToken (token) {
    return http.get(`/user_assignors/token/${token}`)
  }

  withProtesto (token) {
    return http.get(`assignors_with_protestos/campaign/${token}`)
  }

  saveByToken (token, user) {
    return http.post(`/user_assignors/${token}`, { user })
  }

  destroyRepresentativeDocument (representativeId, documentId) {
    const payload = {
      assignor_representative_id: representativeId,
      document_id: documentId
    }
    return http.delete(`/assignors/destroy_representative_documentation`, {params: payload})
  }
}

export default new Assignor()



// WEBPACK FOOTER //
// ./src/services/assignor.js